module.exports = __webpack_public_path__ + "assets/img/6e658424ea83e177f2795470e246d39f.png";